<template>
  <div class="form-group">
    <label :for="idCampo" :class="{ required: campo.obrigatorioSeAtivo }">{{ campo.label }}</label>
    <input
      :id="idCampo"
      :type="tipoInput"
      class="form-control"
      :value="value"
      :placeholder="campo.placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
    />
    <div v-if="erro" class="avisoDanger text-left mt-1">{{ erro }}</div>
  </div>
</template>

<script>
const TIPO_INPUT = { password: 'password', url: 'url', text: 'text' }

export default {
  name: 'CampoTexto',
  props: {
    idCampo: { type: String, required: true },
    campo: { type: Object, required: true },
    value: { default: '' },
    erro: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    tipoInput () {
      return TIPO_INPUT[this.campo.tipo] || 'text'
    }
  }
}
</script>
